import { gql } from '@apollo/client';

export const BLOG_POST_FIELDS = gql`
  fragment BlogPostFields on BlogPost {
    id
    title
    slug
    body
    createdAt
    updatedAt
    tags {
      id
      name
    }
    meta {
      description
      title
      url
    }
    picture {
      id
      path
      path256
    }
    pictureId
  }
`;